import { render, staticRenderFns } from "./mytitle.vue?vue&type=template&id=554d6a58&scoped=true"
import script from "./mytitle.vue?vue&type=script&lang=js"
export * from "./mytitle.vue?vue&type=script&lang=js"
import style0 from "./mytitle.vue?vue&type=style&index=0&id=554d6a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d6a58",
  null
  
)

export default component.exports